import { t } from "@lingui/macro";
import * as React from "react";
import { G, Path, Defs, ClipPath } from "react-native-svg";

import { Icon, IconProps } from "../../../primitive";

export const RacquetsIcon = (props: IconProps) => {
  const clipPathId = React.useId();

  return (
    <Icon fill="none" viewBox="0 0 16 16" title={t`Racquets`} {...props}>
      <G clipPath={`url(#${clipPathId})`}>
        <Path
          fill="currentColor"
          d="M14.758 1.242C12.805-.712 9.232-.32 6.786 2.126c-1.335 1.336-2.103 3.23-2.12 4.558-.016 1.319.217 3.247-1.127 4.591L.575 14.24a.813.813 0 0 0 0 1.15l.035.035a.813.813 0 0 0 1.15 0l2.965-2.965c1.344-1.343 3.272-1.11 4.59-1.126 1.32-.017 3.223-.785 4.559-2.12 2.437-2.446 2.838-6.02.884-7.972Zm-7.68 7.67c-1.277-1.276-.876-3.847.885-5.609 1.762-1.76 4.324-2.162 5.61-.884 1.277 1.277.876 3.848-.885 5.609-1.761 1.761-4.324 2.162-5.61.885Z"
        />
      </G>
      <Defs>
        <ClipPath id={clipPathId}>
          <Path fill="#fff" d="M0 0h16v16H0z" />
        </ClipPath>
      </Defs>
    </Icon>
  );
};
